export default __webpack_public_path__ + "locales/el-GR/JavascriptSdk.json?hash=f4427ee1f74db4b2641508f562637524";